/**
 * Social Share Module
 * Handles social media sharing and URL copying functionality
 */

/**
 * 画面中央にシェアウィンドウを開く
 * @param {string} shareUrl - シェアURL
 */
function openShareWindow(shareUrl) {
  const width = 800;
  const height = 600;
  const left = (screen.width - width) / 2;
  const top = (screen.height - height) / 2;

  const popup = window.open(
    shareUrl,
    '_blank',
    `width=${width},height=${height},left=${left},top=${top}`
  );

  // セキュリティ対策: 元のページにアクセスできなくする
  if (popup) {
    popup.opener = null;
  }
}

/**
 * シェアタイプに応じたURLを生成
 * @param {string} type - シェアタイプ ('x', 'linkedin', 'facebook')
 * @param {string} url - シェアするURL
 * @param {string} title - シェアするタイトル
 * @param {string} description - シェアする説明文（オプション）
 * @returns {string} シェアURL
 */
function getShareUrl(type, url, title, description = '') {
  switch (type) {
    case 'x':
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(title || '')}&url=${encodeURIComponent(url)}`;
    case 'linkedin':
      return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    case 'facebook':
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    default:
      return '';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  /** X（旧Twitter）シェア */
  const xButton = document.querySelector('.js-social-share-x');
  if (xButton) {
    xButton.addEventListener('click', function (event) {
      event.preventDefault();

      const url = xButton.getAttribute('data-url');
      const title = xButton.getAttribute('data-title');
      if (!url) return;

      const shareUrl = getShareUrl('x', url, title);
      openShareWindow(shareUrl);
    });
  }

  /** LinkedInシェア */
  const linkedinButton = document.querySelector('.js-social-share-linkedin');
  if (linkedinButton) {
    linkedinButton.addEventListener('click', function (event) {
      event.preventDefault();

      const url = linkedinButton.getAttribute('data-url');
      const title = linkedinButton.getAttribute('data-title');
      if (!url) return;

      const shareUrl = getShareUrl('linkedin', url, title);
      openShareWindow(shareUrl);
    });
  }

  /** Facebookシェア */
  const facebookButton = document.querySelector('.js-social-share-facebook');
  if (facebookButton) {
    facebookButton.addEventListener('click', function (event) {
      event.preventDefault();

      const url = facebookButton.getAttribute('data-url');
      const title = facebookButton.getAttribute('data-title');
      if (!url) return;

      const shareUrl = getShareUrl('facebook', url, title);
      openShareWindow(shareUrl);
    });
  }

  /** URLコピー */
  const copyButton = document.querySelector('.js-social-share-copy');
  if (copyButton) {
    let tooltip = null;

    const selectors = [
      {
        wrapper: '.c-share__copy-wrap',
        tooltip: '.c-share__copy-tooltip',
      },
      {
        wrapper: '.p-magazine__copy-button-wrapper',
        tooltip: '.p-magazine__copy-tooltip',
      },
      {
        wrapper: '.p-news__copy-button-wrapper',
        tooltip: '.p-news__copy-tooltip',
      },
    ];

    for (const { wrapper, tooltip: tooltipSelector } of selectors) {
      const wrapperEl = copyButton.closest(wrapper);
      if (wrapperEl) {
        tooltip = wrapperEl.querySelector(tooltipSelector);
        break;
      }
    }

    let hideTimeout = null;

    copyButton.addEventListener('click', async function (event) {
      event.preventDefault();

      const url = copyButton.getAttribute('data-url');
      if (!url || !tooltip) return;

      // クリップボードにコピー
      if (!navigator.clipboard?.writeText) return;

      await navigator.clipboard.writeText(url);

      // 既存のタイマーをクリア
      if (hideTimeout) {
        clearTimeout(hideTimeout);
      }

      // ツールチップを表示
      tooltip.setAttribute('aria-hidden', 'false');
      tooltip.classList.add('is-visible');

      // 1秒後に非表示
      hideTimeout = setTimeout(() => {
        tooltip.setAttribute('aria-hidden', 'true');
        tooltip.classList.remove('is-visible');
        hideTimeout = null;
      }, 1000);
    });
  }
});
